import React from "react";
import { Network, ExternalLink } from "lucide-react";
import { T } from "@/context/LanguageContext";

const SITES = [
  { name: "SocialPulse.blog", desc: "Trending local blogs & stories", url: "https://socialpulse.blog", badge: "Blogs" },
  { name: "CivicPulse.blog", desc: "Local government & civic policy", url: "https://civicpulse.blog", badge: "Civics" },
  { name: "Chats.SocialPulse.com", desc: "Live community channels & forums", url: "https://chats.socialpulse.com", badge: "Chat" },
  { name: "PhotoPulse.pro", desc: "High-res local photo gallery", url: "https://photopulse.pro", badge: "Photos" },
  { name: "TravelerPulse.pro", desc: "Curated travel itineraries", url: "https://travelerpulse.pro", badge: "Travel" },
  { name: "FoodPulse.net", desc: "Restaurant guides & reviews", url: "https://foodpulse.net", badge: "Dining" },
];

export function EcosystemRail({ placeName }) {
  return (
    <section data-testid="ecosystem-rail">
      <div className="mb-4 flex items-center gap-2.5 border-b border-border pb-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-navy text-white"><Network className="h-5 w-5" /></span>
        <div>
          <h2 className="font-display text-2xl font-black tracking-tight text-navy sm:text-3xl"><T>Explore the Pulse Network</T></h2>
          <p className="text-xs text-muted-foreground"><T>Specialized community sites connected to</T> {placeName}</p>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="ecosystem-list">
        {SITES.map((s) => (
          <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer"
            className="group flex items-start justify-between gap-3 rounded-xl border border-border bg-white p-4 transition-all hover:-translate-y-0.5 hover:border-navy/30 hover:shadow-md"
            data-testid={`ecosystem-${s.badge.toLowerCase()}`}>
            <div className="min-w-0">
              <div className="mb-1 inline-block rounded bg-oldglory-red/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-oldglory-red">{s.badge}</div>
              <div className="truncate font-display text-base font-bold text-navy group-hover:text-oldglory-red">{s.name}</div>
              <div className="mt-0.5 text-xs text-muted-foreground"><T>{s.desc}</T></div>
            </div>
            <ExternalLink className="h-4 w-4 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
          </a>
        ))}
      </div>
    </section>
  );
}
